import { Alert as NewAlert, type AlertVariant } from '@/ui/Alert/Alert';

import type { Props } from './types';

const levelToVariant: Record<Props['level'], AlertVariant> = {
  default: 'neutral',
  error: 'error',
  info: 'info',
  success: 'success',
  warn: 'warning'
};

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
export default function Alert({
  afterDismiss,
  children,
  level,
  message,
  dismissable = true
}: Props) {
  return (
    <NewAlert
      variant={levelToVariant[level]}
      message={message}
      dismissable={dismissable}
      onDismiss={afterDismiss ? () => afterDismiss(undefined as never) : undefined}>
      {children}
    </NewAlert>
  );
}
